import io from "socket.io-client";
import api from "../services/api";
import { getDeviceHint } from "../helpers/getDeviceHint";


class SocketWorker {
  constructor(companyId , userId) {
    const sessionToken = api.defaults.headers.Authorization

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      // transports: ["websocket", "polling", "flashsocket"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      // INCIDENTE-SQLI-2026-10 (plan aprobado -- opcion A): el JWT ya NO
      // va en "query" -- eso termina en la URL de conexion (?token=...),
      // que nginx guarda en texto plano en su access_log. "auth" viaja
      // en el payload del handshake, nunca en la URL. userId/deviceHint
      // siguen en query -- no son sensibles.
      query: { userId: this.userId, deviceHint: getDeviceHint() || "" },
      auth: { token: this.token }
    });

    this.socket.on("connect", () => {
      // RDS-DIAG-SINTOMA1 (temporal, quitar tras diagnostico): timestamp local
      // del navegador + socketId + companyId en cada (re)conexion.
      console.log(`[RDS-DIAG-SOCKET] connect  ts=${new Date().toISOString()} socketId=${this.socket.id} companyId=${this.companyId}`);
    });

    this.socket.on("disconnect", (reason) => {
      // RDS-DIAG-SINTOMA1 (temporal, quitar tras diagnostico)
      console.log(`[RDS-DIAG-SOCKET] disconnect ts=${new Date().toISOString()} socketId=${this.socket.id} companyId=${this.companyId} reason=${reason}`);
      this.reconnectAfterDelay();
    });

    this.socket.io.on("reconnect_attempt", (attempt) => {
      // RDS-DIAG-SINTOMA1 (temporal, quitar tras diagnostico)
      console.log(`[RDS-DIAG-SOCKET] reconnect_attempt ts=${new Date().toISOString()} companyId=${this.companyId} attempt=${attempt}`);
    });

    this.socket.io.on("reconnect", (attempt) => {
      // RDS-DIAG-SINTOMA1 (temporal, quitar tras diagnostico)
      console.log(`[RDS-DIAG-SOCKET] reconnect ts=${new Date().toISOString()} socketId=${this.socket.id} companyId=${this.companyId} afterAttempts=${attempt}`);
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {

    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // this.connect();
    if (this.eventListeners[event]) {
      // 
      if (callback) {
        // Desconecta um ouvinte específico
        if (this.socket) this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // 

        // Desconecta todos os ouvintes do evento
        if (this.socket) this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // 
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      if (SocketWorker.instance === this) SocketWorker.instance = null
      
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;